import type { components } from '@feedfm/clips-api-client';
import {
  Alert,
  Box,
  Button,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useDemoAppContext } from '../../pages/demo/DemoAppContext';
import './Add.css';

const Add = () => {
  const [clipId, setClipId] = useState('');
  const [response, setResponse] = useState<
    components['schemas']['AddResponse'] | null
  >(null);
  const [error, setError] = useState<string | null>(null);
  const { client, clientId } = useDemoAppContext();

  const timestamp = new Date().toISOString();
  const method = 'Stream';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setResponse(null);

    const response = await client.POST('/v1/add', {
      body: {
        clientId,
        clipId: Number(clipId),
        method: 'Stream',
      },
    });

    if (response.error) {
      setError(response.error.message ?? 'An error occurred');
      return;
    }

    if (response.data) {
      setResponse(response.data);
    }
  };

  return (
    <Paper elevation={3} className="add-paper">
      <Typography variant="h5" component="h2" gutterBottom>
        Add (POST /add)
      </Typography>
      <Typography variant="body2" color="textSecondary">
        This endpoint should be called when a user adds a clip to a piece of
        content.
      </Typography>

      <form onSubmit={handleSubmit}>
        <Box className="add-container">
          <TextField
            fullWidth
            label="Clip ID"
            variant="outlined"
            value={clipId}
            onChange={(e) => {
              setClipId(e.target.value);
            }}
            className="add-textfield"
            type="number"
            required
          />

          <Box className="add-info">
            <Typography variant="body2" color="textSecondary">
              Client ID: {clientId}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Timestamp: {timestamp}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Method: {method}
            </Typography>
          </Box>

          <Button
            fullWidth
            variant="contained"
            type="submit"
            disabled={client.getToken() === ''}
            className="add-button"
          >
            Add Clip
          </Button>
        </Box>
      </form>

      {error && (
        <Alert severity="error" className="add-error">
          {error}
        </Alert>
      )}

      {response && (
        <Box className="add-response">
          <Typography variant="h6" gutterBottom>
            Response:
          </Typography>
          <Paper variant="outlined" className="add-response-paper">
            <pre className="add-response-pre">
              {JSON.stringify(response, null, 2)}
            </pre>
          </Paper>
        </Box>
      )}
    </Paper>
  );
};

export default Add;
